import * as React from 'react';

export const Left = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-1 -1 20 20" {...props}>
    <path
      fill="currentColor"
      d="M6.70421356 8.99751442 12.7146212 15.0079221 12.0075144 15.7150288 5.29 8.99751442 12.0075144 2.28 12.7146212 2.98710678z"
    />
  </svg>
);
